module.exports = __webpack_public_path__ + "img/cs2_cheat_v_3_0.6b42e703.png";